import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import NotFoundScreen from '../screens/NotFoundScreen';
import { RootStackParamList } from '../types/types';
import ArtistTabNavigator from './ArtistTabNavigator';
import FanTabNavigator from './FanTabNavigator';
import FanCreateProfileScreen from '../screens/FanCreateProfile';
import FanGenresScreen from '../screens/FanGenres';
import ArtistCreateProfileScreen from '../screens/ArtistCreateProfile';
import ArtistGenresScreen from '../screens/ArtistGenres';
import CreateSessionScreen from '../screens/CreateSession';
import SessionGenresScreen from '../screens/SessionGenres';
import { useAuthState } from '../auth/authContext';

// A root stack navigator is often used for displaying modals on top of all other content
// Read more here: https://reactnavigation.org/docs/modal
const Stack = createStackNavigator<RootStackParamList>();

// Get information about the user

export default function RootNavigator() {
  const { userType, firstTimeUser } = useAuthState();
  const isFan = userType === 'fan';
  const isArtist = userType === 'artist';

  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      {isFan && firstTimeUser && (
        <>
          <Stack.Screen name="FanProfile" component={FanCreateProfileScreen} />
          <Stack.Screen name="FanGenres" component={FanGenresScreen} />
        </>
      )}
      {isFan && !firstTimeUser && (
        <Stack.Screen
          name="Fan"
          component={FanTabNavigator}
          options={{ cardStyle: { flexGrow: 1 } }} // This HAS TO BE HERE OTHERWISE SAFARI and Mobile do not work
        />
      )}
      {isArtist && firstTimeUser && (
        <>
          <Stack.Screen
            name="ArtistProfile"
            component={ArtistCreateProfileScreen}
          />
          <Stack.Screen name="ArtistGenres" component={ArtistGenresScreen} />
          <Stack.Screen name="CreateSession" component={CreateSessionScreen} />
          <Stack.Screen name="SessionGenres" component={SessionGenresScreen} />
        </>
      )}
      {isArtist && !firstTimeUser && (
        <Stack.Screen
          name="Artist"
          component={ArtistTabNavigator}
          options={{ cardStyle: { flexGrow: 1 } }} // This HAS TO BE HERE OTHERWISE SAFARI and Mobile do not work
        />
      )}
      <Stack.Screen
        name="NotFound"
        component={NotFoundScreen}
        options={{ title: 'Oops!' }}
      />
    </Stack.Navigator>
  );
}
